import MdsEmptyState from '@mds/empty-state-vue3';
import MdsPageShell from '@mds/page-shell-vue3';
import { MdsButton, MdsButtonContainer } from '@mds/button-vue3';
import MdsSection from '@mds/section-vue3';
import MdsAlert from '@mds/alert-vue3';
import MdsPopover from '@mds/popover-vue3';
import MdsDialog from '@mds/dialog-vue3';
import { MdsListGroup, MdsListGroupItem } from '@mds/list-group-vue3';
import MdsLoader from '@mds/loader-vue3';
import MdsModal from '@mds/modal-vue3';
import MdsComboBox from '@mds/combo-box-vue3';
import MdsFieldset from '@mds/fieldset-vue3';
import { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd } from '@mds/data-table-vue3';
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid-vue3";
import MdsCard from '@mds/card-vue3';
import MdsForm from '@mds/form-vue3';
import MdsInput from '@mds/input-vue3';
import { MdsNotification, MdsNotificationContainer } from "@mds/notification-vue3";
import MdsRadioButton from "@mds/radio-button-vue3";
import MdsSearchField from "@mds/search-field-vue3";
import { MdsTabs, MdsTabsItem } from "@mds/tabs-vue3";
import MdsDatePicker from '@mds/date-picker-vue3';
import MdsTextarea from '@mds/textarea-vue3'
import MdsTooltip from '@mds/tooltip-vue3'
import MdsPagination from '@mds/pagination-vue3'
import MdsSelect from "@mds/select-vue3";
import MdsCheckbox from '@mds/checkbox-vue3';


const registerGlobalComponents = (app) => {
  app.component('mds-empty-state', MdsEmptyState);
  app.component('mds-page-shell', MdsPageShell);
  app.component('mds-button', MdsButton);
  app.component('mds-button-container', MdsButtonContainer);
  app.component('mds-section', MdsSection);
  app.component('mds-alert', MdsAlert);
  app.component('mds-popover', MdsPopover);
  app.component('mds-dialog', MdsDialog);
  app.component('mds-list-group', MdsListGroup);
  app.component('mds-list-group-item', MdsListGroupItem);
  app.component('mds-loader', MdsLoader);
  app.component('mds-modal', MdsModal);
  app.component('mds-combo-box', MdsComboBox);
  app.component('mds-fieldset', MdsFieldset);
  app.component('mds-table', MdsTable);
  app.component('mds-thead', MdsThead);
  app.component('mds-tbody', MdsTbody);
  app.component('mds-td', MdsTd);
  app.component('mds-th', MdsTh);
  app.component('mds-tr', MdsTr);
  app.component('mds-layout-grid', MdsLayoutGrid);
  app.component('mds-row', MdsRow);
  app.component('mds-col', MdsCol);
  app.component('mds-card', MdsCard);
  app.component('mds-form', MdsForm);
  app.component('mds-input', MdsInput);
  app.component('mds-notification', MdsNotification);
  app.component('mds-notification-container', MdsNotificationContainer);
  app.component('mds-radio-button', MdsRadioButton);
  app.component('mds-search-field', MdsSearchField);
  app.component('mds-tabs', MdsTabs);
  app.component('mds-tabs-item', MdsTabsItem);
  app.component('mds-date-picker', MdsDatePicker);
  app.component('mds-tooltip', MdsTooltip);
  app.component('mds-textarea', MdsTextarea); 
  app.component('mds-pagination', MdsPagination); 
  app.component('mds-select', MdsSelect);
  app.component('mds-checkbox', MdsCheckbox);
};

export default registerGlobalComponents;